<template>
  <el-select v-bind="$attrs"
             v-on="$listeners"
             v-loading="loading"
             collapse-tags
             multiple>
    <el-option v-for="item in positions"
               :key="item.id"
               :label="item.name"
               :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
  import { positionsMayAuthorize } from '@/utils/request'

  export default {
    name: 'PositionSelect',
    props: {
      organType: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        positions: []
      }
    },
    watch: {
      organType: {
        handler: function (value) {
          this.loading = true
          positionsMayAuthorize(value).then(response => {
            this.positions = response.data
          }).finally(() => {
            this.loading = false
          })
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
</style>
